import script from "./DndListElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./DndListElement.vue?vue&type=script&lang=ts&setup=true"

import "./DndListElement.vue?vue&type=style&index=0&id=66e309b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66e309b6"]])

export default __exports__